import { useEffect } from "react";

import { useLoggedInUser, useUser } from "../api/user-auths/login";
import { mpLogin, mpViewPage } from "../utils/mixpanel";

export const useViewPage = (page: string) => {
  useEffect(() => {
    return () => {
      mpViewPage(page);
    };
  }, []);
};

export const useMixpanelLogin = () => {
  const user = useLoggedInUser();
  useEffect(() => {
    if (user.isSuccess) {
      mpLogin(user.data);
    }
  }, [user.isSuccess]);
};
